<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight task-square">
        <div>
            <!-- 活动广场[[ -->
            <div class="header">
                <div class="header-title">活动广场</div>
            </div>
            <div class="task-square-con">
                <div class="search f-clearfix">
	                <select-box style="font-size: 14px;color:#666" :selectList="allGame" :itemTitle="'游戏'" :selected.sync="params.gameId"></select-box>
	                <div class="list f-fl list-title">
	                    <p class="name f-fl"><label for="keyword">活动名称</label></p>
	                    <div class="g-select f-fl">
	                        <input class="input" name="keyword" type="text" placeholder="请输入活动名称" v-model="params.title">
	                    </div>
	                </div>
	                <div class="inquire f-fr">
	                    <input class="btn" type="button" @click="search" value="查询">
	                </div>
	            </div>

                <!-- 图文列表 -->
                <div class="task-square-list-box">
                	<ul class="task-square-list">
	                	<li class="list-con" :class="task.mission_status == 30 ?'': 'list-con-gray'" v-for="task in taskList" :key="task.id">
							<a href="javascript:;" @click="enterDetail(task.id)">
								<div class="list-img-box f-inlineblock-top">
									<div class="list-con-mask"></div>
									<img class="list-img" :src="getTaskCover(task)">
								</div>

								<div class="list-con-text f-inlineblock-top">
									<div class="list-con-tit">
										<router-link :to="{ name: 'v4-task-detail',params: { detailId: task.id }}">
										<p class="tit-con f-hide-col-1 f-inlineblock-top">{{task.title}}</p>
										</router-link>
										<span class="ico sup-top f-inlineblock-top" v-show="task.tag == 1"></span>
										<span class="ico sup-hot f-inlineblock-top" v-show="task.tag == 2"></span>
										<span class="ico sup-new f-inlineblock-top" v-show="task.tag == 3"></span>
									</div>
									<div class="list-con-bewrite">
										<!-- <p class="f-hide-col-3" v-html="task.mission_desc"></p> -->
										<dl class="generalize">
											<dt class="generalize-title">推广官方渠道</dt>
											<dd class="generalize-cnt f-hide-col-1" :title="task.channels ? task.channels.join(' , ') : ''">
												<span>{{task.channels ? task.channels.join(' , ') : ''}}</span>
											</dd>
										</dl>
										<dl class="generalize">
											<dt class="generalize-title">推广分发账号</dt>
											<dd class="generalize-cnt f-hide-col-1" :title="mediaAccount(task.medias)">
												<span v-for="(account,index) of task.medias" :key="index">
													<span v-if="index!=0"> , </span>{{account.name}}
												</span>
											</dd>
										</dl>
									</div>
									<div class="list-con-bottom f-clearfix">
										<p class="list-con-time f-fl">{{task.start_time | dateFormat('/')}} - {{task.end_time | dateFormat('/')}}</p>
										<p class="list-con-time f-fl">已征图文 {{task.text_num}}</p>
										<p class="list-con-time f-fl">已征视频 {{task.video_num}}</p>
									</div>
									<div></div>
								</div>
								<div class="list-money f-inlineblock-top">
									<i class="ico-money"></i>
									<span class="list-money-num">{{task.budget|moneyFormat(0)}}</span>
								</div>
							</a>
	                		<div class="list-con-btn" v-if='task.mission_status == 30'>
								<span class="list-con-status">征稿中</span>
	                			<a class="g-btn video-btn" href="javascript:;" @click="videoContribute(task.id)" v-show="task.video">视频投稿</a>
	                			<a class="g-btn tuwen-btn" href="javascript:;" @click="pictureContribute(task.id)" v-show="task.text">图文投稿</a>
	                		</div>
							<div class="list-con-btn" v-if='task.mission_status == 40'>
	                			<a class="g-btn over">征集完毕</a>
	                		</div>
							<div class="list-con-btn" v-if='task.mission_status == 50'>
	                			<a class="g-btn over">已结束</a>
	                		</div>
							<div class="list-con-btn" v-if='[55,60,70,80].includes(task.mission_status)'>
	                			<a class="g-btn over">奖励待发放</a>
	                		</div>
							<div class="list-con-btn" v-if='[90,100,110].includes(task.mission_status)'>
	                			<a class="g-btn over">奖励已发放</a>
	                		</div>
	                	</li>
	                </ul>
	                <!-- 分页 -->
	               <pagination
                    v-if="total >0"
                    :total="total"
                    :page-size="params.pageSize"
                    @change="pageChange"
                    ref="pager">
            		</pagination>
                </div>

	            <!-- 空数据 start -->
				<div class="empty" v-if="total == 0">
					<img class="empty-img" src="~Assets/img/pages/v4/radar-no-result.png"/>
				</div>
				<!-- 空数据 end -->
            </div>
            <!-- 活动广场 ]] -->

        	<!-- loading [[ -->
	        <div class="g-loading f-hide">
	        	<img src="~Assets/img/pages/v4/tgl-loding.gif"/>
	        	<p class="loading-text">
	        		<span class="loading-text-con">loading</span>
	        		<em class="spot spot-left"></em>
	        		<em class="spot spot-con"></em>
	        		<em class="spot spot-right"></em>
	        	</p>
	        </div>
	        <!-- loading ]] -->
        </div>
        <real-name-pop ref="realNamePop"></real-name-pop>
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/contribute/task.scss';
</style>
<script>
// 测试代码
import {
    TaskList, AllGame, UserUgcIdentity
} from 'Services/getData';
import {
    dateFormat
} from 'Filters';
import pagination from 'Components/v4/pagination/pagination_v4';
import selectBox from 'Components/v4/dropdown/select_box';
import realNamePop from 'Components/v4/pop/real_name_pop.vue';

export default {
    data() {
        return {
            params: {
                page: 1,
                pageSize: 10,
                gameId: 0,
                title: ''
            },
            taskList: [],
            total: 0,
            allGame: [],
            userIdentityData: {
                tglVerify: {
                    code: ''
                },
                flowUser: {}
            }
        }
    },
    components: {
        pagination,
        selectBox,
        realNamePop
    },
    mounted(){
        this.getAllGame();
        this.getList();
        this.getUserIdentity()
    },
    filters: {
        dateFormat
    },
    methods: {
        async getList() {
            let ret = await TaskList(this.params);
            if (ret.data.code == 0) {
                this.total = ret.data.data.total;
                this.taskList = ret.data.data.missions;
            }
        },
        pageChange (param) {
            this.params.pageSize = param.pageSize;
            this.params.page = param.pageIndex;
            this.getList();
        },
        async getAllGame(){
            let res = await AllGame();
            if (res.data && res.data.data.length) {
                this.allGame = res.data.data;
                this.allGame.unshift({
                    id: 0, name: '全部'
                });
            }
        },
        search() {
            this.params.page = 1;
            this.getList();
        },
    	enterDetail(id){
    		this.$router.push({
    			name: 'v4-task-detail',
    			params: {
    				detailId: id
    			}
    		})
    	},
        async getUserIdentity(){
            let res = await UserUgcIdentity()
            if(res.status == 200 && res.data.code == 0){
                this.userIdentityData = res.data.data;
            }
        },
        videoContribute(taskId){
        	if(!this.userIdentityData.qqVerify){
        		this.$refs.realNamePop.showqqVerify = true;
        		return
        	}
        	if(this.userIdentityData.qqVerify == true && this.userIdentityData.tglAndQqVerify == false){
        		this.$refs.realNamePop.showTglAndQqVerify = true;
        		return
        	}
            this.$router.push({
                name: 'v4-task-video',
                params: {
                    taskId: taskId
                }
            })
        },
        pictureContribute(taskId){
        	if(!this.userIdentityData.qqVerify){
        		this.$refs.realNamePop.showqqVerify = true;
        		return
        	}
        	if(this.userIdentityData.qqVerify == true && this.userIdentityData.tglAndQqVerify == false){
        		this.$refs.realNamePop.showTglAndQqVerify = true;
        		return
        	}
            this.$router.push({
                name: 'v4-task-picture',
                params: {
                    taskId: taskId
                }
            })
        },
    	getTaskCover(task) {
		    let {
                mission_logo, game_logo 
            } = task;
		    if(mission_logo){
		    	return mission_logo
            }
		    return game_logo;
        },
        mediaAccount(medias){
            let res = '';
            medias.forEach((v, k)=>{
                if(k != medias.length-1){
                    res += `${v.name} , `;
                }else{
                    res += v.name;
                }
            })
            return res;
        }
    }
}
</script>
